import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { AlertTriangle, Landmark } from "lucide-react";
import { toast } from "sonner";
import { Q } from "./util";

const PedidoRev = ({ p }) => (
  <div className="rounded-lg border p-2 text-sm space-y-1" data-testid={`rev-pedido-${p.pedido}`}>
    <div className="flex flex-wrap gap-2 items-center"><span className="rounded bg-violet-600 text-white text-xs font-bold px-1.5 py-0.5">{p.pedido}</span><b>{p.cliente}</b>
      <span className="ml-auto font-black" data-testid={`rev-monto-${p.pedido}`}><Q v={p.monto} /></span></div>
    <div className="text-xs text-zinc-600">{p.productos}</div>
    {p.guias && <div className="text-[11px] text-zinc-500">Guías: {p.guias.join(", ")}</div>}
    <div className="text-xs">Anticipos ya facturados: {p.anticipos.length ? p.anticipos.map((a) => <span key={a.numero} className="mr-2"><b>{a.numero}</b> <Q v={a.monto} /> ({a.banco})</span>) : "ninguno"}</div>
    <div className="text-xs">Cobrado: <Q v={p.cod} /> · Saldo del pedido: <Q v={p.saldo} />{p.ya && <b className="text-emerald-700"> · Ya facturado ({p.ya})</b>}</div>
  </div>
);

// Ventana de revisión obligatoria antes de facturar.
export const RevisionDialog = ({ url, params, onConfirm, onClose }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(url, { params }).then(({ data }) => setD(data)).catch((e) => { toast.error(formatApiError(e), { id: `rev-${url}` }); onClose(); });
  }, [url]); // eslint-disable-line react-hooks/exhaustive-deps
  const confirmar = async () => {
    setBusy(true);
    try { await onConfirm(); } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="revision-dialog">
        <DialogHeader><DialogTitle>Revisión antes de facturar</DialogTitle></DialogHeader>
        {!d ? <div className="text-sm text-zinc-500">Cargando…</div> : (
          <div className="space-y-2">
            {d.pedidos.map((p) => <PedidoRev key={p.order_id} p={p} />)}
            <div className="rounded-lg bg-zinc-50 border p-2 text-sm">
              <div className="flex items-center gap-1 font-bold"><Landmark className="w-4 h-4" />Banco(s) donde ingresó el dinero</div>
              {d.bancos.map((b) => <div key={b.banco} className="flex justify-between gap-2" data-testid={`rev-banco-${b.banco}`}><span>{b.banco}{b.referencia ? <span className="text-zinc-500"> · Ref {b.referencia}</span> : ""}</span><Q v={b.monto} /></div>)}
              <div className="text-xs mt-1">Referencia bancaria: <b data-testid="rev-referencia">{d.referencia || "—"}</b></div>
            </div>
            {d.avisos.map((a) => <div key={a} className="text-xs text-amber-800 flex gap-1"><AlertTriangle className="w-4 h-4 shrink-0" />{a}</div>)}
            <div className="flex justify-between text-lg font-black border-t pt-2">Monto a facturar<span data-testid="rev-total"><Q v={d.total} /></span></div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="rev-cancelar">CANCELAR</Button>
          <Button onClick={confirmar} disabled={busy || !d || d.total <= 0} className="bg-emerald-600 hover:bg-emerald-700" data-testid="rev-confirmar">{busy ? "Facturando…" : "CONFIRMAR FACTURACIÓN"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
